module.exports = function prosImageSrc(imageData, format) {
  let imgUrl = '';
  const clearGif = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  imgUrl = imageData;

  if (imgUrl === '') {
    return clearGif;
  } else if (imgUrl && (imgUrl.indexOf('/dyn_img/creativepages') > -1)) {
    return imgUrl;
  }
  imgUrl = 'https://slimages.macysassets.com' + imageData; // eslint-disable-line
  imgUrl += `?scl=1&fmt=${format === 'webp' ? 'webp' : 'jpeg'}`;
  return imgUrl;

  return clearGif; // eslint-disable-line
};
